export class ValidationError extends Error {
  constructor() {
    super();
    // Setting the prototype manually, so we're able to use instanceof.
    // This is recommended approach by TypeScript for extending built-in classes:
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
